module.exports = __webpack_public_path__ + "media/icons/zdjecia-67aafcb5.png";